import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  ImgLoaderWhite,
  ImgBgCallEnd,
  AudioOffHoc,
  AudioOnHoc,
  VideoOffHoc,
  VideoOnHoc,
  BackToChatWhiteHoc
} from "../../../assets/images";
import ReadyToJoin from "./ReadyToJoin";
import CallLinkStatus from "./CallLinkStatus";
import MaxParticipants from "./MaxParticipants";
import { getLocalUserDetails } from "../../../Helpers/Chat/User";
import { CALL_STATUS_CONNECTED } from "../../../Helpers/Call/Constant";
import Video from "../Video";
import { muteLocalAudio, muteLocalVideo, resetCallData } from "../../../callback";
import { getCallDisplayDetailsForOnetoManyCall } from "../../../Helpers/Call/Call";
import { store } from "../../../Redux/store";
import { addCallIntermediate } from "../../../Redux/feature/callIntermediateScreenSlice";
import { showModal } from "../../../Redux/feature/popUpDataSlice";
import SDK from "../../../SDK";
import { addIsMuteListner } from "../../../Redux/feature/calllogsDataSlice";
import { addShowConfrenceData, updateConfrenceData } from "../../../Redux/feature/showConfrenceDataSlice";
import { blockOfflineAction } from "../../../Helpers/Utility";

const MeetingScreenJoin = (props = {}) => {
  const [audioMute, setAudioMute] = useState(false);
  const [videoMute, setVideoMute] = useState(false);
  const [activeScreen, setActiveScreen] = useState({
    loading: true,
    readyToJoin: false,
    callEnd: false,
    invalidLink: false,
    maxParticipants: false
  });
  const [userCallDetails, setUserCallDetails] = useState({});
  const showConfrenceData = useSelector(state => state.showConfrenceData?.data)
  const { isAppOnline } = useSelector((state) => state.appOnlineStatus);
  const { data: callData = {} } = useSelector((state) => state.callIntermediateScreen);


  useEffect(() => {
    if (callData.usersList?.length) {
      let updateArr = getCallDisplayDetailsForOnetoManyCall(callData.usersList || [], "subscribe");
      setUserCallDetails(updateArr);
    } else if (callData.usersList?.length === 0 && activeScreen.readyToJoin) {
      SDK.unsubscribeCall();
      setActiveScreen({
        ...activeScreen,
        loading: false,
        readyToJoin: false,
        callEnd: true
      });
    }
  }, [callData.usersList]);

  const subscribeToCall = async () => {
    const roomLink = callData.link;
    console.log("roomLink",roomLink)
    let vcardData = getLocalUserDetails();
    const updateObj = {
      ...activeScreen,
      loading: false
    };

    if (roomLink && vcardData.nickName) {
      SDK.subscribeCall(roomLink, vcardData.nickName, (response, error) => {
        console.log("subscribeCall :>> ", response, error);
        if (error) {
          if (error.statusCode === 100601) {
            updateObj.invalidLink = true;
          } else if (error.statusCode === 100602) {
            updateObj.callEnd = true;
          } else if (error.statusCode === 100603) {
            updateObj.readyToJoin = false;
            updateObj.maxParticipants = true;
          }
        } else {
          if (response.statusCode === 100500) {
            updateObj.readyToJoin = true;
          }
        }
        setActiveScreen(updateObj);
      });
    } else {
      setActiveScreen(updateObj);
    }
  };

  useEffect(() => {
    subscribeToCall();
  }, []);

  useEffect(() => {
    const { callStatusText = "", status = "" } = showConfrenceData || {};
    if (activeScreen.loading && callStatusText === CALL_STATUS_CONNECTED && status === "LOCALSTREAM") {
      store.dispatch(addCallIntermediate({ show: false }));
    }
  }, [showConfrenceData]);

  useEffect(() => {
    if (Object.keys(showConfrenceData).length && showConfrenceData.localVideoMuted !== videoMute) {
      setVideoMute(showConfrenceData.localVideoMuted);
    }
  }, [showConfrenceData.localVideoMuted]);

  const handleAudioMute = async () => {
    const audioMuteResult = await SDK.muteAudio(!audioMute);
    console.log("Intermediate audioMuteResult :>> ", audioMuteResult?.statusCode);
    if (audioMuteResult?.statusCode === 200) {
      muteLocalAudio(!audioMute);
      setAudioMute(!audioMute);
      store.dispatch(addIsMuteListner(!audioMute));
      store.dispatch(
        addShowConfrenceData({
          ...showConfrenceData,
          localAudioMuted: !audioMute
        })
      );
    } else if (audioMuteResult?.statusCode === 500) {
      store.dispatch(
        showModal({
          open: true,
          modelType: "mediaPermissionDenied",
          statusCode: 100606
        })
      );
    }
  };

  const handleVideoMute = async () => {
    const videoMuteResult = await SDK.muteVideo(!videoMute);
    console.log("Intermediate videoMuteResult :>> ", videoMuteResult?.statusCode);
    if (videoMuteResult?.statusCode === 200) {
      muteLocalVideo(!videoMute);
      setVideoMute(!videoMute);
      store.dispatch(
        updateConfrenceData({
          ...showConfrenceData,
          localVideoMuted: !videoMute
        })
      );
    } else if (videoMuteResult?.statusCode === 500) {
      store.dispatch(
        showModal({
          open: true,
          modelType: "mediaPermissionDenied",
          statusCode: 100607
        })
      );
      store.dispatch(addShowConfrenceData({
        ...showConfrenceData, videoPermissionDisabled: true }));
    }
  };

  const handleTryAgain = () => {
    subscribeToCall();
  };

  const handleBackButton = () => {
    SDK.unsubscribeCall();
    resetCallData();
    setActiveScreen({
      ...activeScreen,
      loading: false
    });
    store.dispatch(addCallIntermediate({ show: false, toggleCallScreen: false }));
    // store.dispatch(resetCallIntermediate())
  };

  const handleJoinCall = async () => {
    if (!isAppOnline) {
      blockOfflineAction()
      return
    }
    if (isAppOnline) {
      setActiveScreen({
        ...activeScreen,
        loading: true
      });
      SDK.joinCall((response, error) => {
        console.log("joinCall result :>> ", response, error);
        if (error) {
          const updateObj = {
            ...activeScreen,
            loading: false
          };
          if (error.statusCode === 100602) {
            updateObj.callEnd = true;
            updateObj.readyToJoin = false;
          } else if (error.statusCode === 100603) {
            updateObj.readyToJoin = false;
            updateObj.maxParticipants = true;
          } else if (error.statusCode === 100605) {
            toast.error("The server is not responding. Please try again later");
          }
          setActiveScreen(updateObj);
        }
      });
    }
  };

  const { loading, readyToJoin, callEnd, invalidLink, maxParticipants } = activeScreen;

  return (
    <div className="join_meeting_wrapper">
      <div className="optionButton">
        <span title="Back to chat" className="BackToChat" onClick={handleBackButton}>
          <i className="backIcon">
            <span className="toggleAnimation"></span>
            <BackToChatWhiteHoc viewBox="0 0 18.334 15.325"/>
          </i>
        </span>
      </div>
      <div
        className="meeting_video_container"
        style={{ background: callEnd || invalidLink ? `url(${ImgBgCallEnd}) no-repeat left center` : "#fff" }}
      >
        {loading && (
          <div className="page-loader">
            <img src={ImgLoaderWhite} alt="message-history" />
          </div>
        )}

        {readyToJoin && (
          <>
            <div className="m_video_container_wrapper">
              <div className="m_video_container">
                <div className="video_container">
                  <div className="alert-badge">
                    {showConfrenceData?.localAudioMuted && (
                      <div className={`badge-list ${showConfrenceData?.localVideoMuted ? "" : "videoOn"}`}>
                        <AudioOffHoc viewBox="0 0 19.144 20.207"/> <span>Microphone off</span>
                      </div>
                    )}
                  </div>
                  {showConfrenceData?.localVideoMuted ? (
                    <div className="CameraOffAlert">
                      <span>Camera off</span>
                    </div>
                  ) : (
                    <Video
                      stream={showConfrenceData?.localStream?.video}
                      muted={showConfrenceData?.localVideoMuted}
                      id={showConfrenceData?.localStream?.video?.id}
                      inverse={true}
                    />
                  )}
                  <div className="m_call_action">
                    <button
                      onClick={handleAudioMute}
                      className={audioMute ? "audioBtnAction mute" : "audioBtnAction "}
                      type="button"
                    >
                      <i className={audioMute ? "audioBtn mute" : "audioBtn "}>
                        {audioMute ? <AudioOffHoc viewBox="0 0 19.144 20.207"/> : <AudioOnHoc viewBox="0 0 10.765 14.609"/>}
                      </i>
                    </button>
                    <button
                      onClick={handleVideoMute}
                      className={videoMute ? "videoBtnAction mute" : "videoBtnAction "}
                      type="button"
                    >
                      <i className={videoMute ? "videoBtn mute" : "videoBtn "}>
                        {videoMute ? <VideoOffHoc viewBox="0 0 13.802 12.882"/> : <VideoOnHoc viewBox="0 0 15.071 9.545"/>}
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <ReadyToJoin
              displayName={userCallDetails?.displayName}
              participantsData={userCallDetails?.participantsData}
              handleTryAgain={handleTryAgain}
              handleCancel={handleBackButton}
              handleJoinCall={handleJoinCall}
            />
          </>
        )}
        {maxParticipants && <MaxParticipants />}
        {callEnd && (
          <>
            <div className="m_video_container_wrapper">
              <div className="m_video_container">
                <div className="video_container">
                  <div className="alert-badge">
                    {showConfrenceData?.localAudioMuted && (
                      <div className={`badge-list ${showConfrenceData?.localVideoMuted ? "" : "videoOn"}`}>
                        <AudioOffHoc viewBox="0 0 19.144 20.207"/> <span>Microphone off</span>
                      </div>
                    )}
                  </div>
                  {showConfrenceData?.localVideoMuted ? (
                    <div className="CameraOffAlert">
                      <span>Camera off</span>
                    </div>
                  ) : (
                    <Video
                      stream={showConfrenceData?.localStream?.video}
                      muted={showConfrenceData?.localVideoMuted}
                      id={showConfrenceData?.localStream?.video?.id}
                      inverse={true}
                    />
                  )}
                  <div className="m_call_action">
                    <button
                      onClick={handleAudioMute}
                      className={audioMute ? "audioBtnAction mute" : "audioBtnAction "}
                      type="button"
                    >
                      <i className={audioMute ? "audioBtn mute" : "audioBtn "}>
                        {audioMute ? <AudioOffHoc viewBox="0 0 19.144 20.207"/> : <AudioOnHoc viewBox="0 0 10.765 14.609"/>}
                      </i>
                    </button>
                    <button
                      onClick={handleVideoMute}
                      className={videoMute ? "videoBtnAction mute" : "videoBtnAction "}
                      type="button"
                    >
                      <i className={videoMute ? "videoBtn mute" : "videoBtn "}>
                        {videoMute ? <VideoOffHoc viewBox="0 0 13.802 12.882"/> : <VideoOnHoc viewBox="0 0 15.071 9.545"/>}
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CallLinkStatus handleBack={handleBackButton} callEndScreen={callEnd} />
          </>
        )}
        {(invalidLink) && <CallLinkStatus handleBack={handleBackButton} callEndScreen={callEnd} />}
      </div>
    </div>
  );
};

export default MeetingScreenJoin;
